import  { useEffect, useState } from "react";
import "./multyitem.css";
import {  useNavigate } from "react-router-dom";
import { LuSearch } from "react-icons/lu";

function Searchbar() {
  const [searchInput, setsearchInput] = useState("");
  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const inputValue = e.target.value.toLowerCase();
    setsearchInput(inputValue);
  };

  const handlesearch = async (e) => {
    if (e.key === "Enter") {
      const RemoveSpace = searchInput.replace(/\s/g,'')
      if(RemoveSpace === ""){
        return alert(`It looks like you didn't search.`)
      }
      navigate(`/result?${searchInput}`)
    }
  }
  return (
    <>
      <div className="searchbar_field">
        <div style={searchBarStyle}>
          <input
            style={inputStyle}
            type="search"
            placeholder="Search..."
            value={searchInput}
            onChange={handleInputChange}
            onKeyDown={handlesearch}
          />
          <span>
            <LuSearch />
          </span>
        </div>
        
      </div>
    </>
  );
}

const searchBarStyle = {
  height: "40px",
  width: "350px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "#2c1f48",
  borderRadius: "0 5px 5px 0",
  padding: "10px 20px",
  color: "white",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  transition: "box-shadow 0.3s ease-in-out",
};

const inputStyle = {
  border: "none",
  outline: "none",
  fontSize: "16px",
  width: "100%",
  backgroundColor: "#2c1f48",
  color: "white",
};

export default Searchbar;
